import { PortType, UserType } from 'types';

// Return type for SetUserAction
export interface SetUserReturn {
    type: string;
    payload: UserType;
}

export interface SetUserAction {
    (user: UserType): SetUserReturn;
}

export const setUserAction: SetUserAction = (user) => {
    return {
        type: 'SET_USER',
        payload: user,
    };
};

// Return type for SetPortIdAction
export interface SetPortIdReturn {
    type: string;
    payload: number;
}

export interface SetPortIdAction {
    (portId: number): SetPortIdReturn;
}

export const setPortIdAction: SetPortIdAction = (portId) => {
    return {
        type: 'SET_PORT_ID',
        payload: portId,
    };
};

export interface SetPortReturn {
    type: string;
    payload: PortType;
}

export interface SetPortAction {
    (port: PortType): SetPortReturn;
}

export const setPortAction: SetPortAction = (port) => {
    return {
        type: 'SET_PORT',
        payload: port,
    };
};
